import { LocalContentProps } from "./types";

type OptionalPropertyOf<T extends object> = Exclude<
  {
    [K in keyof T]: T extends Record<K, T[K]> ? never : K;
  }[keyof T],
  undefined
>;

const defaultState: Pick<
  LocalContentProps["options"],
  OptionalPropertyOf<LocalContentProps["options"]>
> = {
  zoom: 16,
  pitch: 0,
  bearing: 0,
  cooperativeGestures: true,
  distanceUnit: "metric",
  mapProvider: { name: "maptiler" },
  hideScores: false,
  collapseScores: false,
};

export default defaultState;
